import { Spacer } from '@kvdbil/components';
import React, { useEffect, useState } from 'react';
import {
  ArticlesBySlugsDocument,
  ArticlesBySlugsQuery
} from '~/config/generated/graphql';
import { requestErrorHandler } from '~/helpers/notifyError';
import {
  getMostReadArticles,
  MostReadArticle
} from '~/helpers/orchestration/blog';
import { useTranslation } from '~/Locale';
import ArticleCardListBlock from './ArticleCardListBlock';
import ArticleList from './ArticleList';
import { HeadlineSkeleton } from '~/App/shared/components/Skeletons';
import { useSelector } from 'react-redux';
import { localizationSelector } from '~/App/shared/selectors/localization';
import { BlogArticlesBySlugs } from '~/App/shared/interfaces/store/CmsData';
import { useCmsData } from '~/App/shared/hooks/useCmsData';

const MostReadArticles = () => {
  const { t } = useTranslation();
  const { currentLocale } = useSelector(localizationSelector);
  const [mostReadArticles = [], setMostReadArticles] = useState<
    MostReadArticle[]
  >([]);
  const [isMostReadArtFetching = [], setIsMostReadArtFetching] = useState(true);

  useEffect(() => {
    getMostReadArticles()
      .then(setMostReadArticles)
      .catch(requestErrorHandler)
      .finally(() => setIsMostReadArtFetching(false));
  }, []);

  const slugs = mostReadArticles?.map(article => {
    const parts = article.url.split('/');
    return parts[parts.length - 1];
  });

  const { data, fetching } = useCmsData<
    ArticlesBySlugsQuery,
    BlogArticlesBySlugs
  >({
    storeKey: 'blogArticlesBySlugs',
    storeNestedKey: `slugs-${slugs?.join('-')}`,
    query: ArticlesBySlugsDocument,
    options: {
      pause: !mostReadArticles.length,
      variables: {
        // it only gets swedish most read articles urls - requestedLocale is support for other langs
        locale: 'sv',
        requestedLocale: currentLocale,
        slugs
      }
    }
  });

  if (fetching || isMostReadArtFetching) {
    return <MostReadArticlesSkelington />;
  }

  const filteredArticles = data?.allArticles?.filter(
    article => article?.slug && article?.mainCategory?.slug
  );

  if (!filteredArticles?.length) {
    return null;
  }

  return (
    <>
      <Spacer height={3} />
      <ArticleCardListBlock
        categorySlug="none"
        articles={filteredArticles}
        heading={t('Most read articles')}
      />
    </>
  );
};

export const MostReadArticlesSkelington = () => (
  <>
    <Spacer height={3} />
    <HeadlineSkeleton />
    <Spacer height={2} />
    <ArticleList limit={4} isLoading={true} />
  </>
);

export default MostReadArticles;
